import React, { useContext } from "react";
import { observer } from "mobx-react";

import { SportOffer } from "@gp/offer";
import {
	SportOfferContext,
	OfferStoreContext,
	OfferOptionsContext,
} from "@gp/components";

import { BettingTypeColumn } from "./BettingTypeColumn";

export const TournamentHeaderBettingTypeColumns = observer(
	function TournamentHeaderBettingTypeColumns() {
		const {
			configuration: { bettingTypeSelectorsStore: btStore },
		} = useContext(OfferStoreContext);

		const { numberOfColumns } = useContext(OfferOptionsContext);

		const sport = useContext(SportOfferContext) as SportOffer;

		const selectors = btStore.getSportSelector(sport);

		if (sport.isOutright) {
			return null;
		}

		const columns = Object.values(selectors || {}).slice(
			0,
			numberOfColumns
		);

		return (
			<>
				{columns.map((column, index) => (
					<BettingTypeColumn
						key={column != null ? column.name : index}
						column={column}
					/>
				))}
			</>
		);
	}
);
